/* import __COLOCATED_TEMPLATE__ from './sq-field-input-number.hbs.js'; */
// `SqFieldInputNumberComponent` is a variation of `SqInputNumberComponent`, a text field input
// that only accepts numbers. At this time, unlike most formatted input components, `value`
// changes immediately bubble up upon change instead of when the user has "declared" they are
// done editing (return/enter, focus out).
//
// Like other `SqFieldInput` components, the input is technically standalone, but is
// really intended to be nested inside a Form Field block component. The two components
// communicate with each other over event handling and auto fill in placeholder if you don't add one.
//
// Sass dependencies at:
// `app/assets/stylesheets/bridgeport/components/form-elements/formfield/_formfield.sass`
//
// ## Example
//
// {{sq-field-input-number fieldName=name}}

/* eslint square/no-restricted-files:"off" -- unscoped components in this folder are discouraged */
import FieldElementSupport from '@square/glass-ui/utils/field-element-support';
import SqInputNumberComponent from './sq-input-number';
export default class SqFieldInputNumber extends SqInputNumberComponent.extend(FieldElementSupport) {}